const CarDriverAppointStaffComponent = () => import('@/views/WareHouse/CarDriverAppointStaff/CarDriverAppointStaffView')

export default [
    {
        path:'/CarDriverAppointStaffIndex',
        name:'CarDriverAppointStaffComponent',
        component:CarDriverAppointStaffComponent
    }
]